import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })
  let payment_account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'payor',
    path: 'payment_account_id',
  })

  return {
    variables: {
      patient_id,
      payment_account_id,
    },
  }
}
